export enum LocaleEnum {
  EN_US = 'en-US',
  EN_IN = 'en-IN',
  ES_MX = 'es-MX'
}
